"use client";

import { useLayoutEffect, useRef } from "react";

type SplitEl = HTMLElement & { _splitSeeded?: boolean };

/** Text target for GSAP SplitText — React must not own children after seeding. */
export function SplitTarget({
  text,
  className = "uppercase _split",
  as: Tag = "span",
}: {
  text: string;
  className?: string;
  as?: "span" | "div" | "h1" | "h2";
}) {
  const ref = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const el = ref.current as SplitEl | null;
    if (!el) return;
    /* Already SplitText-owned — don't fight GSAP. */
    if (el.querySelector(".SplitClass, ._splitLines")) return;
    if (el._splitSeeded && el.dataset.splitSrc === text) return;
    el.textContent = text;
    el.dataset.splitSrc = text;
    el._splitSeeded = true;
  }, [text]);

  return (
    <Tag ref={ref as never} className={className} suppressHydrationWarning>
      {text}
    </Tag>
  );
}
